/**
 * Render a scaled numeric value with at most two decimals, rounded. Trailing
 * zeros are dropped so a clean `17.5` reads as `17.5`, not `17.50`. Strings
 * are passed through so status text like "running" stays intact.
 */
export const formatWidgetDisplayValue = (
  value: number | string | null,
): string => {
  if (value === null || value === "") return "—";
  return typeof value === "number"
    ? String(Number(value.toFixed(2)))
    : String(value);
};
